import { Component, AfterViewInit, OnInit, OnDestroy, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { correctHeight, detectBody } from './app.helpers';
import { AuthService, User } from './shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Store, select } from '@ngrx/store';
import { IState, initStores } from './shared/store/root.reducer';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettingsService } from './shared/services/app-settings.service';
import { AppParamsActions } from './shared/store/app-params.reducer';
import { OpsFeatures } from './ops-features';
import { DealerService } from 'src/app/shared/services/dealer.service';
import { VersionService } from './shared/services/version.service';
import { environment } from 'src/environments/environment';
import { AppActions } from './shared/store/app.reducer';
import { PendoService } from './shared/services/pendo.service';
import { PendoCofigurationService } from './shared/services/pendo-configuration.service';
const currentUserKey = 'valutrax.ops.id.currentUser';

declare var jQuery: any;
declare global {
  interface Window {
    _walkmeConfig?: any;
    oecWalkmeVariables?: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: []
})

export class AppComponent implements AfterViewInit, OnInit, OnDestroy, AfterViewChecked {
  currentMode: string;
  topBarCssClass: string;
  mainBarCssClass: string;
  pageWrapperCssClass: string;
  tooltipCssClass: string;
  headerPageCssClass = '';
  position = '';
  hasRetrieverPermission = false;
  subscriptions: Subscription[] = [];
  alreadyProcceced = false;
  fontSizeClass = '';
  retrieverSliderCssClass = '';
  showCreateAlertSlider = 'false';
  showAlertDetailsSlider = 'false';
  updateAlertMessages = false;
  isPageNotFoundRoute = false;
  currentUser: User;
  // FullScreen Toggle btn
  public isFullscreen = false;
  showRetreiverSlider: boolean;
  private previousUrl: string;
  private currentUrl: string;

  constructor(
    private router: Router,
    private authService: AuthService,
    public toastr: ToastrService,
    private store: Store<IState>,
    private cdRef: ChangeDetectorRef,
    private dealerService: DealerService,
    public opsFeatures: OpsFeatures,
    public versionService: VersionService,
    private appSettingsService: AppSettingsService,
    private pendoService: PendoService,
    private pendoConfigurationService: PendoCofigurationService) {
  }

  ngOnInit() {
    this.loadWalkmeScripts();
    // Run correctHeight function on load and resize window event
    jQuery(window).bind('load resize', function () {
      correctHeight();
      detectBody();
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (!this.alreadyProcceced) {
          if (!event.url.includes('login')) {
            this.authService.loadUserFromLocalStore();
          }
          this.proccessAppInit();
          this.alreadyProcceced = true;
        }

        if (this.previousUrl) {
          this.store.dispatch({
            type: AppParamsActions.SET_PREVIOUS_URL,
            payload: this.previousUrl
          });
        }
      }
    });
    this.versionService.get().subscribe(result => {
      let versionNumber = result.versionNumber;
      versionNumber = versionNumber.substring(0, versionNumber.length - 2);
      this.store.dispatch({
        type: AppActions.SET_APP_VERSION,
        payload: versionNumber
      });
    });

    window.addEventListener('storage', (event) => {
      // listen for state changes
      let newUser = {} as User;
      if (event.key === currentUserKey && event.newValue !== null && event.newValue !== '') {
          newUser = JSON.parse(event.newValue) as User;
        if (this.currentUser && newUser && this.currentUser.contactId !== newUser.contactId) {
          window.alert('Old session expired. New user: ' + newUser.fullName);
          this.refreshApp();
        }
      }
    });
  }

  refreshApp() {
    const url = `${environment.baseUrl}#/claim-status`;
    window.location.href = url;
    window.location.reload();
  }

  private proccessAppInit() {
    initStores(this.store);
    this.loadStore();
  }

  private loadStore() {
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.currentUser)).subscribe((currentUser) => {
      if (currentUser && currentUser.contactId !== 0) {
        this.currentUser = currentUser;
        if (this.currentUser.id) { this.setPendoInformation(); }
        this.setWalkMeVariables(currentUser);
        this.dealerService.getManufacturers().subscribe(res => {
          this.store.dispatch({
            type: AppParamsActions.SET_MANUFACTURERS,
            payload: res
          });
        });
      }
    }));
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.fullScreen))
      .subscribe(fullScreenState => {
        this.topBarCssClass = fullScreenState.topBarCssClass;
        this.mainBarCssClass = fullScreenState.mainBarCssClass;
        this.pageWrapperCssClass = fullScreenState.pageWrapperCssClass;
        this.tooltipCssClass = fullScreenState.tooltipCssClass;
      }));
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.print))
      .subscribe(printState => {
        this.headerPageCssClass = printState.headerPageCssClass;
      }));
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.appSettings.IsLoaded)).subscribe(isLoadedSettings => {
      if (isLoadedSettings) {
        const fontSize = this.appSettingsService.getSetting('FontSize').value.toString();
        this.setFontSizeClass(fontSize);
      }
    }));
  }

  private setPendoInformation() {
     // get pendo configuration
     this.pendoConfigurationService.getPendoConfiguration().subscribe(pendoConfig => {
      this.currentUser.pendoApiKey = pendoConfig.pendoApiKey;
      this.currentUser.isValutraxPendoEnabled = pendoConfig.valutraxPendoEnabled;

      // load Pendo Script
      if (this.currentUser.isValutraxPendoEnabled) {
        this.pendoConfigurationService.getUserPendoInfo().subscribe(pendoInfo => {
          if (pendoInfo) {
            this.currentUser.pendo = pendoInfo;
            this.pendoService.loadPendo(this.currentUser.pendoApiKey, this.currentUser);
          }
        });
      }
    });
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects === '/page-not-found') {
          this.isPageNotFoundRoute = true;
        } else {
          this.isPageNotFoundRoute = false;
        }
      }
    });
    // Correct height of wrapper after metisMenu animation.
    jQuery('.metismenu a').click(() => {
      setTimeout(() => {
        correctHeight();
      }, 300);
    });
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }

  ngAfterViewChecked() {
    correctHeight();
    detectBody();
    this.cdRef.detectChanges();
  }


  setFontSizeClass(fontSize) {
    const div = document.getElementById('bodyinspinia');
    div.setAttribute('style', 'font-size: ' + fontSize + 'px');
  }
  private loadWalkmeScripts() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    // tslint:disable-next-line:quotemark max-line-length
    script.innerHTML = "(function() {var walkme = document.createElement('script'); walkme.type = 'text/javascript'; walkme.async = true; walkme.src = '" + environment.walkMeConfigUrl + "'; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(walkme, s); window._walkmeConfig = {smartLoad:true}; window.oecWalkmeVariables = {}; })();";
    const head = document.getElementsByTagName('head')[0];
    if (head !== null && head !== undefined) {
      document.head.appendChild(script);
    }
  }

  setWalkMeVariables(currentUser) {
    if (window?.oecWalkmeVariables) {
      window.oecWalkmeVariables.opsInfo = {
        accountType: currentUser.userType === 1 ? 'Shop' : 'Supplier',
        opsTraxId: currentUser.contactId ? currentUser.contactId : '',
        companyId: currentUser.companyId ? currentUser.companyId : ''
      };
      window.oecWalkmeVariables.userInfo = {
        roles: currentUser?.userRoles
      };
      window.oecWalkmeVariables.oecInfo = {
        oecCompanyId: currentUser?.oecCompanyId
      };
    }
  }
}
